import * as Yup from "yup";
import { useMandatoryTypeValidator } from "../../shared/components/validator";

export default function useEmailOtpValidationSchema() {
  return Yup.object().shape({
    emailOtp: useMandatoryTypeValidator(),
  });
}
